<div class="card mb-5" [attr.style]="(data?.colStyle || '') + (data?.rowStyle || '')">
    <div class="card-header" style="border-bottom: none; padding: 10px 12px 8px;">
    <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
      <div class="card-title d-flex flex-column" style="width:100%;">
        <h6 style="margin: 0; width:100%; font-size: calc(16px * var(--dvm-font-scale, 1));" [style.text-align]="data?.titleAlignment || 'center'">{{ data?.title | capitalCase }}</h6>
      </div>
    </div>
  </div>
  <div class="card-body" style="padding: 10px 12px 10px; position: relative;">
    <!-- Chart container: direct child div[id] so global responsive CSS + service font scaling apply -->
    <div #chartContainer [id]="data?.widgetId" style="width: 100%;" [style.height]="getContainerHeight()"></div>

    <div class="scrollbar-track" [style.height]="getContainerHeight()" *ngIf="allCategories.length > maxVisibleBars">
      <div class="scrollbar-thumb"
           [style.height]="getScrollbarThumbHeight() + 'px'"
           [style.top]="getScrollbarThumbTop() + 'px'"
           (mousedown)="onScrollbarMouseDown($event)"></div>
    </div>
  </div>
</div>
